export default __webpack_public_path__ + "static/media/noPosterLarge.dcdec203.jpg";